import FUTUROJA_EXT_1 from "./FUTUROJA_EXT_1";
export default {
  FUTUROJA_EXT_1,
};
